import user from "./user";
import rfis from "./rfis";
import app from "./app"

export default {
  ...user,
  ...rfis,
  ...app
};
